import React from 'react'
import { IHoveringToolbarContext } from '../../utils/types';


export const HoveringToolbarProvider = React.createContext<IHoveringToolbarContext | null>(null);

